module.exports = __webpack_public_path__ + "static/media/37_A.1ee35c4b.png";